<div id="bg-login" class="flex items-center justify-center login animate h-auto bg-color-primary">
    <div class="w-full md:w-3/5 my-2 flex p-5 lg:min-h-[80vh] h-auto min-h-[200px]">

        <!-- Banner lateral izquierdo -->
        <div class="hidden lg:block w-2/5 bg-primary-500 rounded-l-xl relative overflow-hidden">
            <!-- Candado de fondo con opacidad -->
            <div class="absolute inset-0 flex items-center justify-center">
                <img src="assets/images/restore-password2.png" class="opacity-20 w-4/6">

            </div>
        </div>

        <!-- Contenedor del formulario -->
        <div class="w-full lg:w-3/4 bg-white rounded-xl md:rounded-r-xl shadow-lg flex flex-col p-0 md:pb-6">
            <!-- Botón "Volver" arriba a la derecha -->
            <div class="hidden md:block">
                <div class="flex">
                    <div class="w-full items-start flex" style="padding: 3rem 0rem 0rem 3rem;">
                        <div class="logo flex w-1/2" [style.backgroundImage]="'url(' + logoUrl + ')'"></div>
                    </div>
                    <div class="w-full flex justify-end" style="padding: 3rem 3rem 0rem 0rem;">
                        <button (click)="logout()" class="text-sm text-gray-400  flex items-center gap-2">
                            <i class="fas fa-arrow-left text-gray-400 hover:text-primary-500"></i><span>{{
                                'academy.calendar-go-back' | translate
                                }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <!-- Botón "Volver" RESPONSIVE-->
            <div class="block md:hidden">
                <div class="w-full flex justify-start px-8 pt-8 pb-2">
                    <button (click)="logout()"
                        class="text-sm text-gray-500 hover:text-primary-500 flex items-center gap-2">
                        <i class="fas fa-arrow-left text-gray-400 text-base "></i>
                    </button>
                       <div class="w-full justify-end flex" style="padding: 3rem 0rem 0rem 3rem;">
                        <div class="logo flex w-1/4" [style.backgroundImage]="'url(' + logoUrl + ')'"></div>
                    </div>
                </div>
            </div>

            <!-- Contenido centrado horizontal y verticalmente -->
            <div class="flex-1 pb-6 px-4 md:p-0 flex justify-center items-center">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>